import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7218232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper relative" }
const _hoisted_2 = {
  key: 0,
  class: "overlay-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold" }, "Objektkennwort", -1))
const _hoisted_4 = { class: "card mt-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Ihr Objektkennwort in diesem Objekt ")
], -1))
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Hier können Sie das Kennwort ändern, das unsere Leitstelle für Auskunftsanfragen verwendet. Bitte stellen Sie sicher, dass alle berechtigten Personen das neue Kennwort erhalten.")
  ])
], -1))
const _hoisted_8 = { class: "form-group row position-relative" }
const _hoisted_9 = { class: "col-lg-10" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dies ist Ihr aktuelles Objektkennwort", -1))
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Geben Sie hier Ihr neues Objektkennwort ein", -1))
const _hoisted_15 = {
  key: 0,
  class: "card-footer text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_password = _resolveComponent("toggle-password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.shouldDisableInterventionChanges())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (_ctx.currentPassword)
                  ? (_openBlock(), _createBlock(_component_toggle_password, {
                      key: 0,
                      defaultValue: _ctx.currentPassword,
                      placeholderText: 'Objektkennwort',
                      readonly: true
                    }, null, 8, ["defaultValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_toggle_password, {
                  placeholderText: 'neues Objektkennwort eingeben',
                  modelValue: _ctx.newPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                  onPasswordChange: _ctx.handlePasswordChange
                }, null, 8, ["modelValue", "onPasswordChange"])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.shouldDisableInterventionChanges())
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveObjektkennwort && _ctx.saveObjektkennwort(...args)))
            }, "Speichern")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}